module.exports = __webpack_public_path__ + "img/maintenance.a6375c6a.png";